import RequiredPermission from '@/assets/data/RequiredPermission'
import WorkAllocationTab from '@/assets/data/WorkAllocationTab'
import BodyCard from '@/Components/BodyCard'
import HeaderCard from '@/Components/HeaderCard'
import { Button } from '@/Components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/Components/ui/card'
import { Input } from '@/Components/ui/input'
import { Label } from '@/Components/ui/label'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/Components/ui/tabs'
import { useAuth } from '@/Context/AuthContext'
import { checkPermission } from '@/utils/helper'
import { FilterIcon, SquarePlus, CalendarIcon, CircleX, FilterX } from 'lucide-react'
import { useEffect, useReducer, useState } from 'react'
import { Link, useLoaderData, useLocation, useNavigate } from 'react-router-dom'

import { Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from '@/Components/ui/sheet'
import WorkAllocationColumn from './WorkAllocationColumn'
import Datatable from '@/Components/Common/Datatable'
import SearchableDropdown from '@/Components/Common/SearchableDropdown'
import MultipleSelector from '@/Components/Common/MultipleSelector'
import { Select } from '@/Components/ui/select'
import { cn } from '@/lib/utils'
import { Calendar } from '@/Components/ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/Components/ui/popover'

import { format } from 'date-fns'
import WorkAllocationFilter from './WorkAllocationFilter'
import WorkAllocationTable from './WorkAllocationTable'
import { useSidebar } from '@/Components/ui/sidebar'
import { Checkbox } from '@/Components/ui/checkbox'
import WorkAllocationService from '@/Service/WorkAllocationService'
import { useDebounce } from 'use-debounce'
import Constant from '@/utils/Constant'
import { PaginationWithLinks } from '@/Components/Common/Pagination'
import Constent from '@/utils/constent'

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuPortal,
    DropdownMenuSeparator,
    DropdownMenuShortcut,
    DropdownMenuSub,
    DropdownMenuSubContent,
    DropdownMenuSubTrigger,
    DropdownMenuTrigger,
} from '@/Components/ui/dropdown-menu'
import AssignmentPopup from '@/Components/Common/AssignmentPopup'

const WorkAllocation = () => {
    const { payor_type, assessment_type, followupStatus, chartStatus, chartLockIssue, coder, qa, prod_tl, qa_tl } = useLoaderData()
    const { open } = useSidebar()
    const { userInfo } = useAuth()
    const location = useLocation()
    const navigate = useNavigate()
    const [tabcount, setTabcount] = useState({})
    const url = new URLSearchParams(location.search)
    const [currentTab, setCurrentTab] = useState(url?.get('tab') || 'Pending')
    const [event, updateEvent] = useReducer(
        (prev, next) => {
            return { ...prev, ...next }
        },
        {
            workAllocation: [],
            startRowSerial: 1,
            totalWorkAllocation: 0,
            searchWorkallocation: '',
            allCheck: false,
            deleteId: [],
            isDataFetching: false,

            errorData: [],
            errorMessages: [],
            paginatedErrorMessages: [],
            searchFilter: {
                limit: url.get('limit') && url.get('limit') != 'undefined' ? url.get('limit') : Constent.PAGINATION_SIZE,
                page: 1,
                tab: currentTab,
                assessment_type: [],
                payor_type: [],
                chart_status: [],
                mr_number: '',
                patient_name: '',
                qa_name: '',
                prod_tl: '',
                qa_tl: '',
                priority: '',
                coder_chart_assign_date: {},
                qa_chart_assign_date: {},
                chart_lock_issue: '',
                chart_locked_user: '',
                chart_lock: {},
                coder_name: '',
                follow_up_date: {},
                follow_up_status: '',
                coding_level_appeal: '',
                isclear: false,
            },
            isChecked: [],
            checkedAll: false,
            assignmentPopup: false,
            assignType: '',
        }
    )

    useEffect(() => {
        url.set('tab', currentTab)

        updateEvent({
            searchFilter: {
                ...event.searchFilter,
                tab: currentTab,
            },
        })
        navigate(`${location.pathname}?${url.toString()}`, { replace: true })
    }, [currentTab])

    const [searchWorkallocation] = useDebounce(event.searchWorkallocation, Constant.DEBOUNCE_DELAY)

    const getTabCount = async () => {
        // const count_data = await WorkAllocationService.getTabCount()
        // if (count_data.data.success) {
        //     console.log('count data', count_data)
        // }
    }
    const getWorkAllocation = async () => {
        updateEvent({ isDataFetching: true })
        try {
            const workAllocationd = await WorkAllocationService.getWorkAllocation({
                ...event.searchFilter,
                ...(event.searchFilter.follow_up_date?.from &&
                    event.searchFilter.follow_up_date?.to && {
                        follow_up_date: [
                            format(event.searchFilter.follow_up_date.from, Constant.DATE_RANGE_FORMAT),
                            format(event.searchFilter.follow_up_date.to, Constant.DATE_RANGE_FORMAT),
                        ],
                    }),
                ...(event.searchFilter.chart_lock?.from &&
                    event.searchFilter.chart_lock?.to && {
                        chart_lock: [
                            format(event.searchFilter.chart_lock.from, Constant.DATE_RANGE_FORMAT),
                            format(event.searchFilter.chart_lock.to, Constant.DATE_RANGE_FORMAT),
                        ],
                    }),
                ...(event.searchFilter.coder_chart_assign_date?.from &&
                    event.searchFilter.coder_chart_assign_date?.to && {
                        coder_chart_assign_date: [
                            format(event.searchFilter.coder_chart_assign_date.from, Constant.DATE_RANGE_FORMAT),
                            format(event.searchFilter.coder_chart_assign_date.to, Constant.DATE_RANGE_FORMAT),
                        ],
                    }),
                ...(event.searchFilter.qa_chart_assign_date?.from &&
                    event.searchFilter.qa_chart_assign_date?.to && {
                        qa_chart_assign_date: [
                            format(event.searchFilter.qa_chart_assign_date.from, Constant.DATE_RANGE_FORMAT),
                            format(event.searchFilter.qa_chart_assign_date.to, Constant.DATE_RANGE_FORMAT),
                        ],
                    }),
            })
            if (workAllocationd.data.success) {
                updateEvent({
                    workAllocation: workAllocationd.data.data,
                    totalWorkAllocation: workAllocationd.data.pagination.total_record,
                    startRowSerial: workAllocationd.data.pagination?.starting_row_number || 1,
                })
            }
        } catch (err) {
            console.log('error', err)
        }
        updateEvent({ isDataFetching: false })
    }

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            searchFilter: {
                ...event.searchFilter,
                page,
            },
        })
    }, [location.search])

    useEffect(() => {
        getWorkAllocation()
        getTabCount()
    }, [event.searchFilter])

    const clearFilter = () => {
        updateEvent({
            searchFilter: {
                ...event.searchFilter,
                assessment_type: [],
                payor_type: [],
                chart_status: [],
                mr_number: '',
                patient_name: '',
                qa_name: '',
                prod_tl: '',
                qa_tl: '',
                priority: '',
                coder_chart_assign_date: {},
                qa_chart_assign_date: {},
                chart_lock_issue: '',
                chart_locked_user: '',
                chart_lock: {},
                coder_name: '',
                follow_up_date: {},
                follow_up_status: '',
                coding_level_appeal: '',
                isclear: false,
            },
        })
    }

    function chart_assign() {
        let response = WorkAllocationService.assignChartCoder()
        console.log('response', response)
    }

    return (
        <>
            <HeaderCard>
                <div className="flex justify-between items-center">
                    {/* {checkPermission(RequiredPermission.USER.CREATE, userInfo.roles) && (
                        <Button className="bg-primary-btn hover:bg-primary-purpal">
                            <SquarePlus />
                            Assign Chart For Coder
                        </Button>
                    )} */}

                    <Button className="bg-primary-btn hover:bg-primary-purpal" onClick={chart_assign}>
                        <SquarePlus />
                        Assign Chart For Coder
                    </Button>
                    <Button className="bg-primary-btn hover:bg-primary-purpal ml-2">
                        <SquarePlus />
                        Assign Chart For QA
                    </Button>

                    {checkPermission(RequiredPermission.USER.DELETE, userInfo.roles) && (
                        <Link to="/work-allocation/create-work-allocation">
                            <Button className="bg-primary-btn hover:bg-primary-purpal ml-1">
                                <SquarePlus />
                                Create Work Allocation
                            </Button>
                        </Link>
                    )}

                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="outline" className={`ml-2 ${event.isChecked.length > 0 ? 'block' : 'hidden'}`}>
                                Action
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent className="w-56">
                            <DropdownMenuItem onClick={() => updateEvent({ assignmentPopup: true })}>Assign</DropdownMenuItem>
                            <DropdownMenuItem>Re-Assign</DropdownMenuItem>
                            <DropdownMenuItem>Un-Assign</DropdownMenuItem>
                            <DropdownMenuItem>Delete</DropdownMenuItem>
                            <DropdownMenuItem>Chart Lock</DropdownMenuItem>
                        </DropdownMenuContent>
                    </DropdownMenu>
                    <AssignmentPopup open={event.assignmentPopup} setOpen={() => updateEvent({ assignmentPopup: !event.assignmentPopup })} />
                </div>
            </HeaderCard>
            <BodyCard className="pt-0 overflow-hidden">
                <div className="grid  gap-y-2 gap-x-2 mt-[-8px] relative overflow-hidden">
                    <Tabs
                        defaultValue={currentTab}
                        className="relative mr-auto"
                        style={{ width: open ? 'calc(100vw - 276px)' : 'calc(-60px + 100vw)' }}
                    >
                        <TabsList
                            className="flex flex-wrap justify-around [@media(max-width:1296px)]:justify-start 
   gap-1 md:w-[96%] text-muted-foreground rounded-none border-b-2 bg-white-100 h-fit "
                        >
                            {WorkAllocationTab['tabMenu'].map((item) => {
                                return (
                                    <div className="relative group">
                                        <TabsTrigger className="px-5" onClick={() => setCurrentTab(item.tabName)} value={item.tabName}>
                                            <div className="flex w-full gap-1 justify-center items-center">
                                                <span>
                                                    {item.tabName == 'Pending' || item.tabName == 'Completed'
                                                        ? 'WorkList ' + item.tabName
                                                        : item.tabName}
                                                </span>
                                                <span
                                                    className={`flex items-center justify-center px-1 ml-1 text-[9px] font-bold rounded-full ${
                                                        currentTab === item.tabName ? 'bg-purple-900 text-white' : 'bg-gray-400 text-white'
                                                    }`}
                                                >
                                                    {event.totalWorkAllocation}
                                                </span>
                                            </div>
                                        </TabsTrigger>

                                        {item.tabName == 'Coding Post Problem' && currentTab == item.tabName && (
                                            <div className="absolute left-0 top-8 mt-1 hidden group-hover:block bg-white border border-gray-200 shadow-lg p-2 w-full z-50">
                                                <label className="flex items-center space-x-2 ">
                                                    <Checkbox />
                                                    <span>Query</span>
                                                </label>
                                                <label className="flex items-center space-x-2 ">
                                                    <Checkbox />
                                                    <span>TIOC Query</span>
                                                </label>
                                                {followupStatus.map((val) => (
                                                    <>
                                                        <label className="flex items-center space-x-2 ">
                                                            <Checkbox />
                                                            <span>{val.followup_status}</span>
                                                        </label>
                                                    </>
                                                ))}
                                            </div>
                                        )}

                                        {item.tabName == 'Appeals' && currentTab == item.tabName && (
                                            <div className="absolute left-0 top-8 mt-1 hidden group-hover:block bg-white border border-gray-200 shadow-lg p-2 min-w-max z-50">
                                                <label className="flex items-center space-x-2 ">
                                                    <Checkbox />
                                                    <span>Coder 1st Level Appeal</span>
                                                </label>
                                                <label className="flex items-center space-x-2 ">
                                                    <Checkbox />
                                                    <span>Coder 2nd Level Appeal</span>
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                            <div className=" absolute  right-[-15px]  top-2 flex gap-1">
                                <WorkAllocationFilter
                                    assessmentTypeData={assessment_type}
                                    payorTypeData={payor_type}
                                    chartStatusData={chartStatus}
                                    chartLockIssue={chartLockIssue}
                                    followupStatus={followupStatus}
                                    currentTab={currentTab}
                                    event={event}
                                    coder={coder}
                                    prod_tl={prod_tl}
                                    qa={qa}
                                    qa_tl={qa_tl}
                                    updateEvent={updateEvent}
                                />
                                {!event.searchFilter.isclear && (
                                    <Button
                                        variant="outline"
                                        className="mb-0 bg-red-500 text-white hover:bg-red-600 hover:text-white"
                                        onClick={clearFilter}
                                    >
                                        <FilterX size={20} />
                                    </Button>
                                )}
                            </div>
                        </TabsList>

                        {WorkAllocationTab['tabMenu'].map((item) => {
                            return (
                                <>
                                    <TabsContent value={item.tabName} className="overflow-auto overflow-card-scroll h-[calc(100vh-250px)] ">
                                        <WorkAllocationTable
                                            data={event.workAllocation}
                                            columns={WorkAllocationColumn(item.tabName)}
                                            getWorkAllocation={getWorkAllocation}
                                            chartLockIssue={chartLockIssue}
                                            parentEvent={event}
                                            parentUpdateEvent={updateEvent}
                                        />
                                    </TabsContent>
                                </>
                            )
                        })}
                        <PaginationWithLinks
                            totalCount={event.totalWorkAllocation}
                            pageSizeRange={[20, 50, 100]}
                            startSerial={event.startRowSerial}
                            endSerial={parseInt(event.workAllocation.length) + parseInt(event.startRowSerial) - 1}
                            showCountLable={true}
                            onPageCountChange={(limit) => {
                                updateEvent({
                                    searchFilter: {
                                        ...event.searchFilter,
                                        page: 1,
                                        limit,
                                    },
                                })
                            }}
                        />
                    </Tabs>
                </div>
            </BodyCard>
        </>
    )
}

export default WorkAllocation
